
/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";

import getSchema from "../../lib/api/getSchema";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import layoutConf from "../../config/layoutConf";
import AccessControl from "../functional/AccessControl";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import notificationState from "../../states/notificationState";
import { useSetRecoilState } from "recoil";
import UpdateRecordButton from "../input/UpdateRecordButton";
import DeleteRecordButton from "../input/DeleteRecordButton";
import SaveToExcelButton from "../input/SaveToExcelButton";
import { debounce } from "lodash";
import TkElectrodeOrderPurchaseCreateButton from './../input/TkElectrodeOrderPurchaseCreateButton';
import TkElectrodeOrderPurchaseDetailOrder from './TkElectrodeOrderPurchaseDetailOrder';
import TkElectrodeOrderPurchaseMaterialExcelFormDownloadButton from "../input/TkElectrodeOrderPurchaseMaterialExcelFormDownloadButton";

function TkElectrodeOrderPurchaseMst(props) {

    const id = "TkElectrodeOrderPurchaseMst"

    const table = "TkElectrodeOrderPurchaseMst"

    const view = "TkVwElectrodeOrderPurchaseMst"

    const [grid, setGrid] = useState();

    const [onSelectMst, setOnSelectMst] = useState();



    const [height, setHeight] = useState(0);


    const { t } = useTranslation();

    const [schema, setSchema] = useState();

    const [mstApi, setMstApi] = useState();

    const [isEmpty, setIsEmpty] = useState();



    const setNotification = useSetRecoilState(notificationState);

    const handleResize = () => {

        setHeight(document.documentElement.offsetHeight - 96);

    };

    useEffect(() => {

        let mounted = true;

        window.addEventListener('resize', handleResize);
        handleResize();

        (async () => {

            let schema = await getSchema(table);

            if (mounted) {
                setSchema(schema);
            }

        })();

        return (() => {
            mounted = false;
            window.removeEventListener('resize', handleResize);
        });


    }, []);

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.selectionChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectMst(grid.selectedItems[0])

                    } else {

                        setOnSelectMst([]);

                    };

                }), 10);

                grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectMst(grid.selectedItems[0])

                    } else {

                        setOnSelectMst([]);

                    };

                }), 10);
            }

        })()

    }, [grid])

    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false)

    }

    const onInitialized = grid => {

        setGrid(grid);

    };

    const onApiInitialized = (api) => {

        setMstApi(api);

    };

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onSuccess = (msg) => {

        notifySuccess(msg);

    };

    const notifyFailure = (msg) => {

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onFailure = (reason) => {

        notifyFailure(reason.response ? reason.response.data : reason);

    };

    const notifyWarning = (msg) => {

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const onNotifyWarning = (msg) => {

        notifyWarning(msg);

    };

    return (

        <div style={{ height: height }} >

            <ReflexContainer orientation="horizontal">

                <ReflexElement flex={0.6}>

                    <BasicCrudScreenType
                        id={id}
                        headerTitle={t("term.tkElectrodeOrderPurchaseMst")}
                        table={table}
                        view={view}
                        onInitialized={onInitialized}
                        onApiInitialized={onApiInitialized}
                        onLoadData={onLoadData}
                        exportFormatItem={() => { }}
                        noCreate
                        noEdit
                        noDelete
                        noExcel
                        onAppendButtonInFrontOfSearch={
                            () => (
                                <>
                                    <BasicCrudScreenActionItemLayout>

                                        <AccessControl accessTarget={schema && schema.name} accessMethod="POST">
                                            <TkElectrodeOrderPurchaseCreateButton
                                                id={id}
                                                schema={schema}
                                                refresh={mstApi}
                                                onSuccess={onSuccess}
                                            />
                                        </AccessControl>

                                        <AccessControl accessTarget={schema && schema.name} accessMethod={schema && (schema.updateWithPatch ? "PATCH" : "PUT")}>
                                            <UpdateRecordButton
                                                id={id}
                                                schema={schema}
                                                grid={grid}
                                                refresh={mstApi}
                                                disabled={onSelectMst?.approvalState ? true : false || isEmpty}
                                                onSuccess={onSuccess}
                                            />
                                        </AccessControl>

                                        <AccessControl accessTarget={schema && schema.name} accessMethod="DELETE">
                                            <DeleteRecordButton
                                                id={id}
                                                schema={schema}
                                                grid={grid}
                                                refresh={mstApi}
                                                color="secondary"
                                                disabled={onSelectMst?.approvalState ? true : false || isEmpty}
                                                onSuccess={onSuccess}
                                                onFailure={onFailure}
                                                onPartialFailure={onNotifyWarning}
                                            />
                                        </AccessControl>

                                        <AccessControl accessTarget={schema && schema.name} accessMethod="SAVETOEXCEL">
                                            <SaveToExcelButton
                                                id={id}
                                                grid={grid}
                                                view={view}
                                                color="primary"
                                                exportFormatItem={() => { }}
                                                disabled={isEmpty}
                                            />
                                        </AccessControl>

                                        <TkElectrodeOrderPurchaseMaterialExcelFormDownloadButton
                                            id={id}
                                            schema={schema}
                                            refresh={mstApi}
                                            grid={grid}
                                            electrodeOrderPurchaseSelect={onSelectMst}
                                            onSuccess={onSuccess}
                                        />

                                    </BasicCrudScreenActionItemLayout>
                                </>
                            )
                        }
                    />

                </ReflexElement>

                <ReflexSplitter style={{ height: layoutConf.reflex.splitterHeight }} />

                <ReflexElement>
                    <TkElectrodeOrderPurchaseDetailOrder onSelectMst={onSelectMst} />

                </ReflexElement>
            </ReflexContainer>

        </div>

    );

}

export default TkElectrodeOrderPurchaseMst;
